import * as React from "react";
import { SectionCommon } from "./layout/section-common";
import { Features } from "./features";
import { FeatureProps } from "./feature";
import { PricingLink } from "./pricing-link";

export const FiveStarRated = ({ features }: { features: FeatureProps[] }) => (
  <SectionCommon
    title="5 Star Rated on Clutch"
    text="Best-in-class white label services and support you won’t find elsewhere."
  >
    <Features features={features} />
    <PricingLink to="/pricing" className="btn-brand">
      SEE PLANS & PRICING
    </PricingLink>
  </SectionCommon>
);
